module.exports = __webpack_public_path__ + "static/curso_pluma-5d68fe7ba10f9aebd431c155616e03bd.jpg";